//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Pagination from '@/common/mixins/pagination'
import Service from '../../service'
export default {
    mixins: [Pagination],
    data() {
        return {
            loading: true,
            items: []
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            const data = await Service.getLoansHistory({
                page: this.page,
                per: 10
            })
            this.loading = false
            this.handleData(data)
        }
    }
}
